import React from 'react';
const WarningSign = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='25' viewBox='0 0 20 25'>
      <defs>
        <clipPath>
          <path d='M0 0h20v25H0z' fill='none' />
        </clipPath>
      </defs>
      <g id='icons_attention_i-2'>
        <path d='M0 0h20v25H0z' fill='none' />
        <g id='icons_attention_i-3' clipPath='url(#clipPath)'>
          <path
            fill='var(--theme-primary, #810ea9)'
            stroke='var(--theme-primary, #810ea9)'
            strokeMiterlimit='10'
            d='M10 25a.566.566 0 0 1-.318-.1c-3.91-2.63-6.39-4.43-7.848-7.235C.3 14.688 0 10.675 0 4.75a.606.606 0 0 1 .355-.55L9.766.046A.491.491 0 0 1 9.943 0h.072a.484.484 0 0 1 .219.046L19.656 4.2a.594.594 0 0 1 .344.55c0 5.925-.3 9.938-1.834 12.919-1.467 2.822-3.944 4.616-7.848 7.235A.563.563 0 0 1 10 25zm.005-23.762L1.188 5.129c.023 6.387.48 9.637 1.688 11.993 1.3 2.507 3.669 4.225 7.129 6.56 3.465-2.345 5.834-4.068 7.118-6.56 1.219-2.357 1.677-5.607 1.688-11.993l-8.806-3.892z'
            transform='translate(0 0)'
          />
          <path d='M1.48 0a1.487 1.487 0 0 0 0 2.974A1.487 1.487 0 0 0 1.48 0z' fill='var(--theme-primary, #810ea9)' transform='translate(8.526 15.181)' />
          <path
            d='M1.48 0A1.485 1.485 0 0 0 0 1.487l.3 5.358a1.184 1.184 0 0 0 1.18 1.192 1.182 1.182 0 0 0 1.167-1.192l.3-5.358A1.483 1.483 0 0 0 1.48 0z'
            fill='var(--theme-primary, #810ea9)'
            transform='translate(8.526 6.258)'
          />
        </g>
      </g>
    </svg>
  );
};

export default WarningSign;
